import classNames from "classnames";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { Article } from "@Types/cart";
import { getUpsellsToDisplay, hasProductUpsells } from "@Utils/upsells";
import "./style.scss";

export interface Props {
  article: Article;
  smallDesign: boolean;
}

const CartUpsells: FunctionComponent<Props> = ({ article, smallDesign }) => {
  const intl = useIntl();

  const upsellsList = hasProductUpsells(article.product.tag)
    ? getUpsellsToDisplay(article.additionalOptions)
    : [];

  return (
    <>
      {upsellsList.length > 0 ? (
        <div
          className={classNames("CartUpsells", {
            "CartUpsells--outOfStock": article.product.outOfStock,
            "CartUpsells--small": smallDesign,
          })}
        >
          {upsellsList.map((option) => {
            return (
              <div className="CartUpsells-upsell" key={option.tag}>
                <div className="CartUpsells-upsell-bullet" />
                {option.productOptionTag === "amount"
                  ? intl.formatMessage(
                      { id: "cheerz_UpsellsModal_title__amount" },
                      {
                        giftAmount: intl.formatNumber(option.total.cents / 100, {
                          currency: article.total.currency,
                          style: "currency",
                        }),
                        printedCard: intl.formatNumber(article.product.priceCents / 100, {
                          currency: article.total.currency,
                          style: "currency",
                        }),
                      }
                    )
                  : option.title}
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default CartUpsells;
